'use client';

import Image from 'next/image';
import { PROJECT_NAME } from '@shared/constants';

/**
 * @group Employers
 * @summary Features section for employers page
 */
export function EmployerFeaturesSection() {
  return (
    <section className="py-20 bg-hero-bg">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden max-h-[500px]">
              <Image
                src="/img/happy_employees.jpg"
                alt="Happy employees"
                fill
                className="object-contain"
              />
            </div>
          </div>
          
          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-3xl lg:text-4xl font-bold text-hero-text mb-6">
              Reducing Burnout, Protecting Autonomy
            </h2>
            <div className="space-y-4 text-[#B8B4B0] leading-relaxed">
              <p>
                Traditional healthcare access often requires employees to take half a day or more off work for a simple consultation. {PROJECT_NAME} enables employees to address health concerns during lunch breaks or between meetings — dramatically reducing lost productivity.
              </p>
              <p>
                For employers, this means less disruption, lower costs from absenteeism, and employees who return to work faster. For employees, it means not having to choose between their health and their responsibilities.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
